import initDebug from 'debug';

const debug = initDebug('canopy:promise');

/* Used by monetization bundle */
function promisify(func) {
  return (...args) => new Promise((resolve, reject) => {
    func(...args, (err, data) => (err) ? reject(err) : resolve(data));
  });
}

function promiseAll(props) {
  const keys = Object.keys(props);
  return Promise.all(keys.map(key => (props[key])))
    .then(results => (
      results.reduce((total, currentValue, currentIndex) => {
        /* eslint-disable */
        total[keys[currentIndex]] = currentValue;
        return total;
      }, {}))
    )
    .catch ((err) => {
      debug(`promiseAll keys=${keys} err=${err}`);
      throw err;
    });
}
function promiseChain(tasks) {
  if (!Array.isArray(tasks)) {
    return Promise.resolve([]);
  }
  return tasks.reduce((promiseChain, currentTask) => {
    return promiseChain.then(chainResults => {
      const promise = currentTask;
      if (promise) {
        return currentTask.get().then(currentResult => [...chainResults, currentResult]);
      } else {
        debug('promise undefined or null');
        return chainResults;
      }
    });
  }, Promise.resolve([]));
}

function promiseChainWithGetter(tasks) {
  if (!Array.isArray(tasks)) {
    return Promise.resolve([]);
  }
  return tasks.reduce((promiseChain, currentTask) => {
    return promiseChain.then(chainResults => {
      const promise = currentTask.get();
      if (promise) {
        return currentTask.get().then(currentResult => [...chainResults, currentResult]);
      } else {
        debug('promise with getter undefined or null');
        return chainResults;
      }
    });
  }, Promise.resolve([]));
}

export { promisify, promiseAll, promiseChain, promiseChainWithGetter };
